import styled, {css} from 'styled-components';

import {colors, buttonReset, border, transition} from 'theme';

import {ButtonVariant} from './constants';

export const Inner = styled.span`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 24px;
`;

export const NativeButton = styled.button<{
    isLoading: boolean;
    disabled: boolean;
    variant: ButtonVariant;
    size?: 'sm' | 'md' | 'lg';
}>`
    ${buttonReset};

    position: relative;
    display: inline-block;
    vertical-align: top;
    border-radius: ${border.radius};
    font-weight: 600;
    height: 44px;
    font-size: 14px;
    line-height: 24px;
    border-style: solid;
    border-width: 1px;
    transition: all ${transition.duration};
    width: 100%;
    box-sizing: border-box;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};

    ${(p) =>
        p.isLoading &&
        css`
            ${Inner} {
                opacity: 0;
            }
        `}
    
    ${(p) =>
        p.size === 'sm' &&
        css`
            font-size: 12px;
            line-height: 16px;
            height: 36px;

            ${Inner} {
                padding: 10px 16px;
            }
        `}

    ${(p) =>
        p.size === 'lg' &&
        css`
            font-size: 16px;
            line-height: 20px;
            height: 52px;

            ${Inner} {
                padding: 14px 32px;
            }
        `}

    ${(p) =>
        p.variant === ButtonVariant.Normal &&
        css`
            background-color: ${colors.brandPrimary};
            border-color: ${colors.brandPrimary};
            color: ${colors.white};

            &:disabled {
                background-color: ${colors.textMuted};
                border-color: ${colors.textMuted};
                box-shadow: none;
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                background-color: ${colors.brandDark};
                border-color: ${colors.brandDark}};
            }
        `}
    

    ${(p) =>
        p.variant === ButtonVariant.Outline &&
        css`
            background-color: ${colors.transparent};
            border-color: ${colors.brandPrimary};
            color: ${colors.brandPrimary};

            &:disabled {
                border-color: ${colors.textMuted};
                color: ${colors.textMuted};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                border-color: ${colors.brandDark}};
                color: ${colors.brandDark};
            }
        `}

    ${(p) =>
        p.variant === ButtonVariant.OutlineSecondary &&
        css`
            background-color: #f2f7ff;
            border-color: ${colors.brandPrimary};
            color: ${colors.brandPrimary};

            &:disabled {
                color: ${colors.lightGrey};
                border-color: ${colors.textMuted};
                color: ${colors.textMuted};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                border-color: ${colors.brandDark}};
                color: ${colors.brandDark};
            }
        `}

    ${(p) =>
        p.variant === ButtonVariant.Cancel &&
        css`
            background-color: ${colors.transparent};
            border-color: ${colors.red};
            color: ${colors.red};

            &:disabled {
                border-color: ${colors.textMuted};
                color: ${colors.background};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                border-color: ${colors.danger}};
                color: ${colors.danger};
            }
        `}

    ${(p) =>
        p.variant === ButtonVariant.Text &&
        css`
            background-color: ${colors.transparent};
            border-color: ${colors.transparent};
            color: ${colors.brandPrimary};

            &:disabled {
                color: ${colors.background};
            }

            &:not(:disabled):hover {
                color: ${colors.brandDark};
            }

            &:not(:disabled):focus-visible {
                box-shadow: 0 0 0 1px ${colors.brandDark};
            }
        `}
    
    ${(p) =>
        p.variant === ButtonVariant.Secondary &&
        css`
            background-color: ${colors.brandLight};
            border-color: ${colors.brandLight};
            color: ${colors.brandPrimary};

            &:disabled {
                background-color: #efefef;
                border-color: #efefef;
                box-shadow: none;
                color: #8a8a8a;
            }

            &:not(:disabled):hover {
                background-color: ${colors.brandPrimary};
                border-color: ${colors.brandPrimary};
                color: ${colors.white};
            }
            &:not(:disabled):focus-visible {
                background-color: ${colors.brandLight};
                border-color: ${colors.brandLight};
                color: ${colors.brandPrimary};
                border-color: #ff7f37;
            }
        `}

    ${(p) =>
        p.variant === ButtonVariant.Unblock &&
        css`
            background-color: ${colors.success};
            border-color: ${colors.success};
            color: ${colors.white};

            &:disabled {
                background-color: ${colors.successSecondary};
                border-color: ${colors.successSecondary};
                color: ${colors.white};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                background-color: ${colors.successHover};
                border-color: ${colors.successHover};
                color: ${colors.white};
            }
        `}
`;

export const IconWrapper = styled.span`
    margin-right: 12px;
`;

export const LoadingIndicatorContainer = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
